<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 14:20:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-04 18:03:55
-->
<template>
	<span class="flex-row flex-align-center">
		<el-button @click="click" :loading="loading">
			<i class="el-icon-loading" v-if="isLoading"></i>
			{{ curStatus.btnText }}
		</el-button>
		<template>
			<p v-if="isLoading" class="yx-color-text-regular fz-14 ml-10">
				<template v-if="ratio">
					商品数据同步进度：
					<span class="yx-color-primary">{{ ratio | formatPercent }}</span>
				</template>
				<template v-else>{{ errMsg }}</template>
			</p>
			<p v-else-if="isError" class="yx-color-warning fz-14 ml-10">
				<el-tooltip :content="errMsg" placement="bottom">
					<span>
						<i class="el-icon-warning"></i>
						同步失败
					</span>
				</el-tooltip>
			</p>
			<p v-else class="yx-color-text-regular fz-14 ml-10">最近同步时间：{{ syncTime }}</p>
		</template>
		<async-dialog ref="asyncDialog" :sourceData="sourceData" @reAsync="startSingleAsyncTask"></async-dialog>
		<auth-alert-dialog ref="authAlertDialog"></auth-alert-dialog>
		<tips ref="tips"></tips>
		<choose-async-task-dialog :sync_info="sync_info" ref="chooseAsyncTaskDialog" @startAsyncTask="startAsyncTask"></choose-async-task-dialog>
	</span>
</template>
<script>
import AsyncDialog from '../asyncDialog.vue';
import authMixin from '@/modules/auth/mixin';
import AuthAlertDialog from '@/modules/auth/alert';
import ChooseAsyncTaskDialog from './chooseAsyncTaskDialog.vue';
import { teamCurrentTask, pollGetTaskInfo } from '@/api/user';
import LoopManger from '@/utils/loop';
import { syncProduct } from '@/api/shopManage';
import { ASYNC_DEFAULT_STATUS, ASYNC_PENDING_STATUS, ASYNC_SUCCESS_STATUS, ASYNC_FAIL_STATUS } from '@/utils/dataMap';
const statusConf = {
	[ASYNC_DEFAULT_STATUS]: {
		btnText: '同步商品',
	},
	[ASYNC_PENDING_STATUS]: {
		btnText: '同步中',
	},
	[ASYNC_FAIL_STATUS]: {
		btnText: '同步商品',
	},
	[ASYNC_SUCCESS_STATUS]: {
		btnText: '同步商品',
	},
};
const taskTypes = {
	singleTask: 'sync_product_lib_product',
	multiTask: 'sync_product_lib_activity_product',
};
export default {
	name: 'GoodsAsyncButton',
	mixins: [authMixin],
	props: {
		type: {
			type: String,
			default: 'singleTask',
			validator: val => ['singleTask', 'multiTask'].includes(val),
		},
		platformId: {
			type: [Number, String],
			default: +dataMap.PLATFORM_DY.value,
		},
		needAuth: {
			type: Boolean,
			default: false,
		},
		sync_info: {
			type: Object,
			default: () => {
				return null;
			},
		},
	},
	watch: {
		platformId: {
			handler(to) {
				this.reset();
				this.getCurrentTask();
			},
			immediate: true,
		},
	},
	data() {
		return {
			status: 'default', // 按钮当前状态，包括default,pending,success,fail四种状态
			taskId: '', // 当前任务ID
			ratio: 0, // 进度条比例
			errMsg: '', // 错误提示信息
			syncTime: '-', // 最近同步时间
			loading: false, // 同步商品按钮loading状态
			isFirst: false, // 全新用户标识（全新用户接口无法返回任务信息，需要特殊处理）
			loop: null, // 定时器对象
			sourceData: {},
			failTimes: 0, // 轮询失败次数
			asyncParams: {},
		};
	},
	computed: {
		isDefault() {
			return this.status === ASYNC_DEFAULT_STATUS;
		},
		isLoading() {
			return this.status === ASYNC_PENDING_STATUS;
		},
		isError() {
			return this.status === ASYNC_FAIL_STATUS;
		},
		isSuccess() {
			return this.status === ASYNC_SUCCESS_STATUS;
		},
		curStatus() {
			return statusConf[this.status] || [];
		},
		tasktType() {
			return taskTypes[this.type];
		},
	},
	methods: {
		async getCurrentTask() {
			return new Promise(async (rs, rj) => {
				try {
					const { code, data } = await teamCurrentTask({
						task_type: this.tasktType,
						platform_id: this.platformId,
						task_option: 'common',
					});
					if (code === 0) {
						// 如果返回的data为空数组定义为未进行过同步任务的用户，将状态变更为默认状态
						if (Array.isArray(data) && !data.length) {
							this.status = ASYNC_DEFAULT_STATUS;
							this.isFirst = true;
						} else {
							this.status = data.result_code;
							this.ratio = data.ratio;
							this.errMsg = data.result_msg;
							this.asyncParams.task_id = data.detail?.task_id;
							this.syncTime = data.detail?.sync_time;
							this.sourceData = data;
						}
						// 当前任务为进行中状态时进行任务轮询
						if (this.status === ASYNC_PENDING_STATUS) {
							this.pollGetTaskInfo();
						}
						return rs();
					}
					return rj('接口异常');
				} catch (error) {
					this.$message.error(error.mesage);
					return rj(error);
				}
			});
		},
		async click() {
			// 如果当前状态是pending状态展示进度弹窗
			if (this.status === ASYNC_PENDING_STATUS) {
				this.showAsyncDialog();
				return;
			}
			// 非pending状态设置同步按钮为loading状态
			this.loading = true;
			try {
				// 检查是否第一次数据获取失败，获取失败点击按钮进行接口重试
				if (this.isDefault && !this.isFirst) {
					await this.getCurrentTask();
				}
				// 如果需要进行授权检测
				if (this.needAuth) {
					await this.checkAuth(this.platformId);
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				return;
			}
			// 如果需要进行单任务处理
			if (this.type === 'singleTask') {
				this.startSingleAsyncTask();
			} else {
				this.$refs.chooseAsyncTaskDialog.show(this.platformId);
			}
			this.loading = false;
		},
		// 开始单个任务（商品库）
		async startSingleAsyncTask() {
			try {
				const { authority_id, item_id, item_id1, activityType: type, institution_id, product_status, regimentalChecked } = this.asyncParams;
				let params = {
					platform_id: this.platformId,
					authority_id,
					item_id,
					item_id1,
					type,
				};
				if (this.$isKs(this.platformId) && [1, 2].includes(regimentalChecked)) {
					params.product_status = product_status;
				}

				const { code, data } = await syncProduct(params);
				if (code === 0) {
					let parmas = {
						task_id: data.task_id,
						authority_id,
						item_id,
						item_id1,
						activityType: type,
						institution_id: institution_id,
					};
					this.startAsyncTask(parmas);
				}
			} catch (error) {
				this.$message.error(error.mesage);
			}
		},
		// 单个任务进度查找
		getTaskInfo() {
			return new Promise(async (rs, rj) => {
				try {
					const { code, data, message } = await pollGetTaskInfo({
						task_id: this.asyncParams.task_id,
						task_option: 'common',
						team_id: this.asyncParams.team_id,
						institution_id: this.asyncParams.institution_id,
					});
					if (code === 0) {
						this.status = data.result_code;
						this.ratio = data.ratio;
						this.errMsg = data.result_msg;
						this.syncTime = data.detail?.sync_time;
						this.sourceData = data;
						return rs(data);
					}
					return rj({ code, message });
				} catch (error) {
					return rj(error);
				}
			});
		},
		async pollGetTaskInfo(taskId) {
			taskId && (this.asyncParams.task_id = taskId);
			return new Promise(async rs => {
				if (this.loop) {
					this.loop.start();
				} else {
					this.loop = new LoopManger(this.pollCallBack);
				}
				this.failTimes = 0;
				return rs();
			});
		},
		showAsyncDialog() {
			this.$refs.asyncDialog.show();
		},
		async pollCallBack() {
			return new Promise(async rs => {
				try {
					await this.getTaskInfo();
					rs();
					// 成功就把失败次数清零
					this.failTimes = 0;
					// 结果成功或者失败就停止轮询
					if (this.isSuccess || this.isError) this.clearLoop();
					// clearInterval(this.timer);
					// 结果成功弹出成功message
					if (this.isSuccess) this.$message.success('商品同步成功'), this.$emit('refresh');
				} catch (error) {
					// 接口获取失败一次就把失败次数+1
					this.failTimes += 1;
					if (this.failTimes >= 3) {
						this.$message.error('接口失败次数过多，请稍后重试');
						// 还原
						this.reset();
					}
				}
			});
		},
		async startAsyncTask(obj) {
			this.asyncParams = obj;
			// 开启任务成功之后进行任务信息轮询
			await this.pollGetTaskInfo();
			// 展示进度弹窗
			this.showAsyncDialog();
		},
		// 把状态置为默认状态，最近同步时间置为‘-’，关闭同步进度弹窗，清除定时器
		reset() {
			this.status = ASYNC_DEFAULT_STATUS;
			this.syncTime = '-';
			this.$refs.asyncDialog?.hide();
			this.clearLoop();
			this.failTimes = 0;
		},
		clearLoop() {
			this.loop?.stop();
			this.loop = null;
		},
	},
	beforeDestroy() {
		this.clearLoop();
	},
	components: {
		AsyncDialog,
		Tips: () => import('@/modules/auth/tips.vue'),
		AuthAlertDialog,
		ChooseAsyncTaskDialog,
	},
};
</script>
